import React from 'react';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import RegisterForm from '../../components/RegisterForm/RegisterForm';
import AuthFooter from '../../components/ui/AuthFooter/AuthFooter';

const RegisterPage = () => {
    return (
        <div>
            <BreadCrumb />
            <RegisterForm />
            <AuthFooter />
        </div>
    );
};

export default RegisterPage;